export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      user: {
        userUuid: 'xxxxxx',
        name: 'xxxxxx',
        email: 'xxxxxx',
        roleKbn: 1,
        service: {
          serviceUuid: 'xxxxxx',
          serviceName: 'xxxxxx'
        },
        linkedCmss:[
          {
            linkedCmsMstId:1,
            linkedCmsName: 'xxxxxx',
            linkedCmsUrl: 'xxxxxx'
          }
        ],
        lastLoginAt: 1594880785395
      },
      accessToken: 'xxxxxx',
      qrcode: 'xxxxxx'
    }
  }
}